export default "__VITE_ASSET__b70f1157__"